export const getProjectMappingRoute = (projectId: string, mappingId = '') =>
  `/projects/${projectId}/mapping/${mappingId}`;
